export default function Article4() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <div className="flex gap-4">
              <a 
                href="/blog"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Volver al Blog
              </a>
              <a 
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-home-line mr-2"></i>
                Inicio
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Article Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              Mantenimiento
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-calendar-line"></i>
              <span>28 Diciembre 2024</span>
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-time-line"></i>
              <span>5 min lectura</span>
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Mantenimiento Preventivo de Extintores: Checklist Completo
          </h1>
          
          <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/9ac52a0427061a5b47f1b5322283f5d1.jpg"
              alt="Mantenimiento Preventivo de Extintores"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Body */}
        <div className="prose prose-lg max-w-none">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-700 font-medium">
              El mantenimiento adecuado de los extintores es fundamental para garantizar su funcionamiento en caso de emergencia. Esta guía proporciona un checklist completo para inspecciones trimestrales y anuales.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Periodicidad del Mantenimiento</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Según el Reglamento de Instalaciones de Protección contra Incendios (RIPCI), los extintores requieren:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Revisión trimestral:</strong> Inspección visual del usuario</li>
            <li><strong>Revisión anual:</strong> Mantenimiento por empresa mantenedora</li>
            <li><strong>Retimbrado:</strong> Cada 5 años (según tipo de extintor)</li>
            <li><strong>Vida útil:</strong> Máximo 20 años desde fabricación</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Checklist Revisión Trimestral</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Inspección Visual Básica</h3>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Accesibilidad:</strong> El extintor está visible y accesible sin obstáculos</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Señalización:</strong> La señal de ubicación está visible y en buen estado</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Estado exterior:</strong> Sin golpes, corrosión o daños visibles</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Manómetro:</strong> La aguja está en la zona verde (presión correcta)</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Precinto:</strong> El precinto de seguridad está intacto</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Manguera:</strong> Sin grietas, obstrucciones o deterioro</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-emerald-600 text-xl mt-0.5"></i>
                <span><strong>Etiquetas:</strong> Legibles y con información actualizada</span>
              </li>
            </ul>
          </div>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Registro de Inspección</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Cada revisión trimestral debe documentarse:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Fecha de la inspección</li>
            <li>Identificación del extintor (número de serie)</li>
            <li>Estado general (conforme/no conforme)</li>
            <li>Observaciones o incidencias detectadas</li>
            <li>Firma del responsable de la inspección</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Checklist Revisión Anual</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Operaciones de Mantenimiento</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            El mantenimiento anual debe ser realizado por empresa mantenedora autorizada e incluye:
          </p>

          <div className="space-y-6 mb-8">
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <span className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">1</span>
                <span>Comprobación de Peso y Presión</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm ml-10">
                <li>• Verificar peso total del extintor</li>
                <li>• Comprobar presión del manómetro</li>
                <li>• Reponer presión si es necesario</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <span className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">2</span>
                <span>Inspección de Componentes</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm ml-10">
                <li>• Estado de manguera y boquilla</li>
                <li>• Funcionamiento de válvula y manómetro</li>
                <li>• Estado del asa y pasador</li>
                <li>• Integridad del recipiente</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <span className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">3</span>
                <span>Limpieza y Conservación</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm ml-10">
                <li>• Limpieza exterior del extintor</li>
                <li>• Eliminación de corrosión superficial</li>
                <li>• Aplicación de pintura si es necesario</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <span className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">4</span>
                <span>Actualización de Etiquetas</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm ml-10">
                <li>• Colocación de etiqueta de mantenimiento</li>
                <li>• Fecha de próxima revisión</li>
                <li>• Identificación de empresa mantenedora</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <span className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">5</span>
                <span>Pruebas Funcionales</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm ml-10">
                <li>• Verificación de mecanismo de disparo</li>
                <li>• Comprobación de estanqueidad</li>
                <li>• Test de funcionamiento (sin descarga)</li>
              </ul>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Retimbrado y Prueba Hidráulica</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Cada 5 años, los extintores deben someterse a retimbrado:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Prueba hidráulica:</strong> Verificación de resistencia del recipiente</li>
            <li><strong>Recarga completa:</strong> Sustitución total del agente extintor</li>
            <li><strong>Sustitución de componentes:</strong> Cambio de juntas y elementos deteriorados</li>
            <li><strong>Marcado de retimbrado:</strong> Actualización de fecha en el extintor</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Causas Comunes de No Conformidad</h2>
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
            <h4 className="font-semibold text-red-900 mb-3">Problemas Frecuentes Detectados</h4>
            <ul className="text-red-800 space-y-2">
              <li>• Pérdida de presión por fugas en válvula o manómetro</li>
              <li>• Precinto roto o ausente</li>
              <li>• Corrosión en el recipiente o componentes</li>
              <li>• Obstrucción en manguera o boquilla</li>
              <li>• Etiquetas ilegibles o desprendidas</li>
              <li>• Extintor caducado (más de 20 años)</li>
            </ul>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Documentación Obligatoria</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Es obligatorio mantener un registro que incluya:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Certificado de instalación inicial</li>
            <li>Libro de mantenimiento con todas las revisiones</li>
            <li>Certificados de retimbrado</li>
            <li>Facturas de mantenimientos realizados</li>
            <li>Contrato con empresa mantenedora autorizada</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Recomendaciones Adicionales</h2>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <ul className="text-gray-700 space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mt-0.5"></i>
                <span>Realizar formación periódica al personal sobre uso de extintores</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mt-0.5"></i>
                <span>Mantener un plano actualizado con ubicación de todos los extintores</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mt-0.5"></i>
                <span>Establecer recordatorios automáticos para revisiones</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mt-0.5"></i>
                <span>Digitalizar toda la documentación de mantenimiento</span>
              </li>
            </ul>
          </div>

          {/* CTA Box */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-8 text-white mt-12">
            <h3 className="text-2xl font-bold mb-4">¿Necesitas mantenimiento de extintores?</h3>
            <p className="mb-6 text-emerald-50">
              Somos empresa mantenedora autorizada. Realizamos todas las revisiones y mantenimientos según normativa vigente.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/citas"
                className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all text-center whitespace-nowrap"
              >
                Solicitar Mantenimiento
              </a>
              <a 
                href="/#contacto"
                className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-all text-center whitespace-nowrap"
              >
                Más Información
              </a>
            </div>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/blog"
            className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Volver al Blog</span>
          </a>
        </div>
      </article>
    </div>
  );
}